<template>
  <div class="custom-wrapper">

    <!-- # RESPONSIVE BOX SETTINGS -->

    <DxResponsiveBox :screen-by-width="screenByWidth" single-column-screen="xs" id="responsive-box" width="100%">
      <DxRow :ratio="1" />
      <DxRow :ratio="1" />
      <DxRow :ratio="1" />
      <DxRow :ratio="1" />
      <DxRow :ratio="1" />
      <DxRow :ratio="1" />
<!--      <DxRow :ratio="1" />-->

      <DxCol :ratio="1" />
      <DxCol :ratio="1" />
      <DxCol :ratio="1" />
      <DxCol :ratio="1" />

      <!-- # FILTERS -->
      <DxItem class="category-list-selector">
        <DxLocation :row="0" :col="0" :colspan="4" screen="xs sm md lg" />
        <template #default >
          <div class="filterContainer">

            <!-- # STORE FILTER -->
            <div class="storeSelectorContainer">
              <!--                          temp-->
              <DxSelectBox style="font-family: 'Nunito'"
                           :dataSource="getOutletsList.filter(item => item.id != 0)"
                           displayExpr= "name"
                           :show-clear-button="false"
                           :placeholder="$store.state.selectedOutlet.name"
                           value-expr="id"
                           :onValueChanged="onOutletSelected"
                           :disabled="!pageDataReady"
                           styling-mode="underlined"
              />
              <!--                     v-model="selectedOutlet"-->

            </div>

            <div class="filtersContainer">
              <div>
                <!-- # CALENDAR FILTER -->
  <!--              <div class="display-calendar-btn" @click="onShowCalendar">{{ displayStringDate }}</div>-->
  <!--              <div class="display-calendar-btn" @click="onShowCalendar">{{ $store.state.selectedDate ? (new Date($store.state.selectedDate.slice(0,4), ($store.state.selectedDate.slice(4,6) - 1), $store.state.selectedDate.slice(6,8))).toLocaleString('en-us', { month: 'short' }) + " " + $store.state.selectedDate.slice(0,4) : (new Date($store.state.outletLastSalesDates.salesLastDayClosedMonth.slice(0,4), ($store.state.outletLastSalesDates.salesLastDayClosedMonth.slice(4,6) - 1), $store.state.outletLastSalesDates.salesLastDayClosedMonth.slice(6,8))).toLocaleString('en-us', { month: 'short' }) + " " + $store.state.outletLastSalesDates.salesLastDayClosedMonth.slice(0,4) }}</div>-->
                <div class="display-calendar-btn" @click="onShowCalendar">{{ $store.state.selectedDate ? (new Date($store.state.selectedDate.slice(0,4), ($store.state.selectedDate.slice(4,6) - 1), $store.state.selectedDate.slice(6,8))).toLocaleString('en-us', { month: 'short' }) + " " + $store.state.selectedDate.slice(0,4) : (new Date(String($store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(0,4), (String($store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(4,6)), String($store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(6,8))).toLocaleString('en-us', { month: 'short' }) + " " + String($store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(0,4) }}</div>

                <!--              <div class="display-calendar-btn" @click="onShowCalendar">{{ $store.state.selectedDate ? $store.state.selectedDate : $store.state.outletLastSalesDates.salesLastDayClosedMonth }}</div>-->
                <div :class="['calendarContainer', calendarHidden ? 'calendarHidden' : '']">
                  <div class="closeCalendarBtn" @click="onShowCalendar">x</div>
                  <div class="calendarButton">
                    <div class="calendarButtonTitle"></div>
                    <button v-for="(dateBtn, ix) in [{name: 'month', value: 'year'}, {name: 'week', value: 'month'}]" :key="ix"
                            :class="[(dateBtn.name + '-btn'), calendarZoomLevel === dateBtn.value ? 'activeDate' : '', dateBtn.value === 'month' ? 'disabled-btn' : '']"
                            @click="onCalendarZoomLevelSelection(dateBtn)"
                            :disabled="dateBtn.value === 'month'"
                    >{{ dateBtn.name }}</button>
                  </div>
                  <div class="calendarComponentContainer">
                    <div class="calendarTitle">{{ loc.FILTERS.CALENDARREFTITLE }}</div>
                    <DxCalendar
                        @value-changed="onSelectedDate"
                        :zoom-level="calendarZoomLevel"
                        :max-zoom-level="calendarZoomLevel"
                        :max="maxSelectableDate"
                        :min="minSelectableDate"
                        :value="$store.state.selectedDate ? `${$store.state.selectedDate.slice(0,4)}-${$store.state.selectedDate.slice(4,6)}-01` : `${('' + $store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(0,4)}-${('' + $store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(4,6)}-01`"
                        cell-template="customCalendarCellTemplate"
                    >
                      <!--                        :disabled-dates="disabledDates"-->
                      <!--                        :value="(this.$store.state.selectedDate === null ? this.$store.state.outletLastSalesDates.salesLastDay : this.$store.state.selectedDate)"-->
                      <!--                        v-model="currentValue"-->
                      <!--                        :min="minDateValue"-->
                      <!--                        :max="maxDateValue"-->
                      <!--                        :disabled-dates="disabledDates"-->
                      <!--                        :first-day-of-week="firstDay"-->
                      <!--                        :disabled="disabled"-->
                      <!--                        :cell-template="cellTemplate"-->
                      <!--                        <template #custom="{ data: cell }">-->
                      <!--                          <span :class="getCellCssClass(cell.date)">-->
                      <!--                            {{ cell.text }}-->
                      <!--                          </span>-->
                      <!--                        </template>-->
                      <template #customCalendarCellTemplate="{ data: data, index }">
                        <CustomCalendarCellTemplate :data="data" :cell-index="index" />
                      </template>
                    </DxCalendar>
                  </div>
                </div>


                <!--Settings-->
                <div class="display-settings-btn" @click="onShowSettings"><i class="dx-icon dx-icon-preferences fa-4x"></i></div>
                <div :class="['calendarContainer', settingsHidden ? 'calendarHidden' : '']">
                  <div class="closeCalendarBtn" @click="onShowSettings">x</div>
                  <div class="calendarButton">
                    <div class="calendarButtonTitle"></div>
                    <button v-for="(dateBtn, ix) in [{name: 'year', value: 'year'}]" :key="ix"
                            :class="[(dateBtn.name + '-btn'), calendarZoomLevel === dateBtn.value ? 'activeDate' : '', dateBtn.value === 'month' ? 'disabled-btn' : '']"
                            @click="onCalendarZoomLevelSelection(dateBtn)"
                            :disabled="dateBtn.value === 'year'"
                    >
                      {{ dateBtn.name }}
                    </button>
                  </div>
                  <div class="calendarComponentContainer">
                    <div class="calendarTitle">{{ loc.FILTERS.CALENDARCOMPARISONTITLE }}</div>
                    <DxCalendar
                        @value-changed="onSelectedSetting"
                        :zoom-level="settingsZoomLevel"
                        :max-zoom-level="settingsZoomLevel"
                        :min-zoom-level="settingsZoomLevel"
                        :max="settingsMaxSelectableDate"
                        :min="settingsMinSelectableDate"
                        :value="$store.state.selectedSettings ? `${$store.state.selectedSettings.slice(0,4)}` : `${ '' + (('' + $store.state.newOutletLastSalesDates.lastAvailableSalesDate).slice(0,4)-1) }`"
                    >
                    </DxCalendar>
                  </div>
                </div>
              </div>

              <!-- # PRODUCT CATEGORIES FILTER -->
              <div class="categoriesListSelectorContainer" style="width: 350px; font-family: 'Nunito'">
                <DxSelectBox style="font-family: 'Nunito'"
                             :dataSource="getCategoriesList"
                             displayExpr= "description"
                             :placeholder="loc.FILTERS.PRODCATPLACEHOLDER"
                             value-expr="id"
                             :onValueChanged="onProductCategorySelected"
                             :disabled="!pageDataReady || productCategoryFilterDisabledByPage"
                             :show-clear-button="true"
                             styling-mode="underlined"
                             :value="$store.state.selectedCategory"


                />
                <!--                       v-model="selectedCategory"-->
                <!--                    <DxTextBoxButton name="clear" :options="{ }"/>-->
              </div>

            </div>
          </div>
        </template>
      </DxItem>


      <!-- ############## 1st row ############## -->

      <!--      #alimentato da footfallSnapshot-->
      <DxItem class="item text">
        <DxLocation :row="1" :col="0" :colspan="2" screen="xs sm md lg" />
        <template #default >
          <basic-text-visualizer
              :component-title="loc.FOOTFALL.VISITORSTEXTTITLEREF"
              :comparison-date="comparisonDateREF"
              :comparison-value="textVisitors.dataFilteredByProductCategoryREF.visitorsREFPY"
              :ref-date="refDateREF"
              :ref-value="textVisitors.dataFilteredByProductCategoryREF.visitorsREF"
              :trend-value="textVisitors.dataFilteredByProductCategoryREF.varVisitors"
          />
        </template>
      </DxItem>

      <!--      #alimentato da footfallTotalsYTD-->
      <DxItem class="item text">
        <DxLocation :row="1" :col="2" :colspan="2" screen="xs sm md lg" />
        <template #default >
          <basic-text-visualizer
            :component-title="loc.FOOTFALL.VISITORSTEXTTITLE"
            :comparison-date="comparisonDateYTD"
            :comparison-value="textVisitors.dataFilteredByProductCategory.visitorsPY"
            :ref-date="refDateYTD"
            :ref-value="textVisitors.dataFilteredByProductCategory.visitors"
            :trend-value="textVisitors.dataFilteredByProductCategory.varVisitors"
          />
        </template>
      </DxItem>

      <!--      #alimentato da footfallSnapshot-->
      <DxItem class="item text">
        <DxLocation :row="2" :col="0" :colspan="2" screen="xs sm md lg" />
        <template #default >
          <basic-text-visualizer
              :component-title="loc.FOOTFALL.CRTEXTTITLEREF"
              :comparison-date="comparisonDateREF"
              :comparison-value="textVisitors.dataFilteredByProductCategoryREF.crREFPY"
              :ref-date="refDateREF"
              :ref-value="textVisitors.dataFilteredByProductCategoryREF.crREF"
              :trend-value="textVisitors.dataFilteredByProductCategoryREF.varCR"
              :is-percentage="true"
              :is-delta-number="true"
          />
        </template>
      </DxItem>

      <!--      #alimentato da footfallTotalsYTD-->
      <DxItem class="item text">
        <DxLocation :row="2" :col="2" :colspan="2" screen="xs sm md lg" />
        <template #default >
          <basic-text-visualizer
            :component-title="loc.FOOTFALL.CRTEXTTITLE"
            :comparison-date="comparisonDateYTD"
            :comparison-value="textVisitors.dataFilteredByProductCategory.crPY"
            :ref-date="refDateYTD"
            :ref-value="textVisitors.dataFilteredByProductCategory.cr"
            :trend-value="textVisitors.dataFilteredByProductCategory.varCR"
            :is-percentage="true"
            :is-delta-number="true"
          />
        </template>
      </DxItem>




      <!-- ############## 3rd row ############## -->
      <DxItem>
        <DxLocation :row="3" :col="0" :colspan="4" screen="xs sm md lg" />
        <template #default>
          <div style="position: relative;">

            <DxButton
                :style="`display: ${dataDisplayMode1 == 'chart' ? 'block' : 'none'}`"
                id="reset-zoom"
                class="reset-zoom-btn"
                :on-click="resetScatterErZoom1"
                :text="loc.COMMON.RESETZOOMTEXT"
            />

            <basic-chart-datagrid-visualizer
                :componentTitle="loc.FOOTFALL.VISITORSTITLE"
                :refDate="null"
                :dataReady="pageDataReady"
                :switch-table-btn="loc.FOOTFALL.CHARTDATAGRIDSWITCHTABLE"
                :switch-chart-btn="loc.FOOTFALL.CHARTDATAGRIDSWITCHCHART"
                topComment=""
                @changeDisplayDataChild="changeDisplayData1($event)"
            >

              <!-- ## LINE CHART -->
              <template v-slot:componentChart>
                <DxChart @drawn="onDrawn"
                         id="scatterChart-filtered-by-client"
                         :data-source="scatterDatagridERLTM.dataFilteredByProductCategory"
                         class="scatterChart"
                         :commonAxisSettings="scatterChartCommonAxisSettings"
                         :loadingIndicator="{enabled: true}"
                         @initialized="saveScatterErInstance1"
                >
                  <DxZoomAndPan
                      :drag-to-zoom="true"
                      pan-key="ctrl"
                      argument-axis="both"
                      value-axis="both"
                      :allow-touch-gestures="true"
                  />
                  <DxCommonSeriesSettings type="line" />
                  <DxSeries argument-field="periodOrdinal" value-field="visitorsPY" :color="getOutletStyle.secondaryColor" :name="displayPreviousYear">
                    <DxPoint :color="getOutletStyle.secondaryColor" :size="scatterERLTM.points2.size" :visible="true" />
                  </DxSeries>
                  <DxSeries argument-field="periodOrdinal" value-field="visitors" :color="getOutletStyle.primaryColor" :name="displayCurrentYear">
                    <DxPoint :color="getOutletStyle.primaryColor" :size="scatterERLTM.points1.size" :visible="true" />
                  </DxSeries>
                  <DxTooltip :enabled="true" content-template="tooltipTemplateFootfall" :argument-format="scatterERLTM.tooltipVisitors.argumentFormat" :format="scatterERLTM.tooltipVisitors.valueFormat" />

                  <DxArgumentAxis :tick-interval="1" :title="loc.FOOTFALL.LINECHARTARGAXISTITLE" :label="{ customizeText: newArgAxisValue }">
                    <DxGrid :visible="false" />
                    <DxMinorGrid :visible="false" />
                  </DxArgumentAxis>
                  <!--                      todo: applicare colore corretto a grid di entrambi gli assi (e fissare quella di asse argument - anche se di default già ok) -->
                  <!--                      todo: togliere primo e ultimo asse di argument grid -->
                  <DxValueAxis
                      :tick-interval="20"
                      :grid="{ visible: true }"
                      :title="loc.FOOTFALL.LINECHART1VALUEAXISTITLE"
                      :visible="false"
                  />
                  <DxLegend
                      :visible="true"
                      vertical-alignment="bottom"
                      horizontal-alignment="center"
                      :margin="{ top: 25 }"
                      itemTextPosition="right"
                      :font="getLegendFontSettings"
                  />
                  <DxCommonPaneSettings>
                    <DxBorder :visible="false" />
                  </DxCommonPaneSettings>

                  <template #tooltipTemplateFootfall="{ data }">
                    <div style="text-align: center">
                      Visitors: {{ data.valueText }}<br>
                      Month: {{ (data.point.series.getValueFields() == "visitors") ? data.point.data.periodPlainAlt : data.point.data.periodPlainAltPY}}
                    </div>
                  </template>

                </DxChart>
              </template>

              <template v-slot:componentTab>
                <!-- ## DATAGRID -->
                <DxDataGrid
                    id="dataGrid-filtered-by-client"
                    class="datagrid"
                    :data-source="scatterDatagridERLTM.dataFilteredByProductCategory"
                    key-expr="periodOrdinal"
                    :show-borders="false"
                    :loadPanel="{enabled: true}"
                    @exporting="onExportingDatagridEr"
                    :show-column-lines="false"
                    :show-row-lines="true"
                    :column-auto-width="true"
                    :column-hiding-enabled="true"
                    :noDataText="loc.COMMON.NODATA"
                >
                  <DxPaging :enabled="false" />
                  <DxExport
                      :enabled="true"
                  />
                  <DxColumn
                      css-class="cell-custom-style cell-body-head"
                      data-field="periodOrdinal"
                      :caption="loc.FOOTFALL.DATAGRIDVISITORSCOL1CAPTION"
                      data-type="number"
                      alignment="left"
                      cell-template="ordinal-to-month"
                      sort-order="asc"

                  />
                  <DxColumn
                      css-class="cell-custom-style"
                      data-field="visitors"
                      :caption="loc.FOOTFALL.DATAGRIDVISITORSCOL2CAPTION + ' ' + yearText"
                      data-type="number"
                      alignment="left"
                      :customizeText="customizeDatagridDataDecimals"
                  >
                    <DxFormat
                        type="fixedPoint"
                        :precision="0"
                    />
                  </DxColumn>
                  <DxColumn
                      css-class="cell-custom-style"
                      data-field="visitorsPY"
                      :caption="loc.FOOTFALL.DATAGRIDVISITORSCOL2CAPTION + ' ' + yearTextPy"
                      data-type="number"
                      alignment="left"
                      :customizeText="customizeDatagridDataDecimals"
                  >
                    <DxFormat
                        type="fixedPoint"
                        :precision="0"
                    />
                  </DxColumn>
                  <DxColumn
                      css-class="cell-custom-style"
                      data-field="varVisitors"
                      :caption="loc.FOOTFALL.DATAGRIDVISITORSCOL4CAPTION"
                      data-type="number"
                      alignment="left"
                      :customizeText="customizeDatagridDataPercentage"
                      cell-template="posNegCellTemplateSales"
                  >
                    <DxFormat
                        type="fixedPoint"
                        :precision="2"
                    />
                  </DxColumn>

                  <!-- template personalizzato celle datagrid -->
                  <template #diff-cell-template="{ data }">
                    <DiffCell :cell-data="data"/>
                  </template>

                  <template #ordinal-to-month="{ data }">
                    <div>{{ fromOrdinalToMonth(data.value) }}</div>
                  </template>

                  <template #posNegCellTemplateSales="{ data }">
                    <div :class="data.value != null ? data.value < 0 ? 'negative-value' : '' : ''">{{ data.text}}</div>
                  </template>

                </DxDataGrid>
              </template>


            </basic-chart-datagrid-visualizer>
          </div>

        </template>
      </DxItem>

      <!-- ############## 4th row ############## -->
      <DxItem>
        <DxLocation :row="4" :col="0" :colspan="4" screen="xs sm md lg" />
        <template #default>
          <div style="position: relative;">

            <DxButton
                :style="`display: ${dataDisplayMode2 == 'chart' ? 'block' : 'none'}`"
                id="reset-zoom"
                class="reset-zoom-btn"
                :on-click="resetScatterErZoom2"
                :text="loc.COMMON.RESETZOOMTEXT"
            />

            <basic-chart-datagrid-visualizer
                :componentTitle="loc.FOOTFALL.CRTITLE"
                :refDate="null"
                :dataReady="pageDataReady"
                :switch-table-btn="loc.FOOTFALL.CHARTDATAGRIDSWITCHTABLE"
                :switch-chart-btn="loc.FOOTFALL.CHARTDATAGRIDSWITCHCHART"
                topComment=""
                @changeDisplayDataChild="changeDisplayData2($event)"
            >

              <!-- ## LINE CHART -->
              <template v-slot:componentChart>
                <DxChart @drawn="onDrawn"
                         id="scatterChart-filtered-by-client"
                         :data-source="scatterDatagridERLTM.dataFilteredByProductCategory"
                         class="scatterChart"
                         :commonAxisSettings="scatterChartCommonAxisSettings"
                         :loadingIndicator="{enabled: true}"
                         @initialized="saveScatterErInstance2"
                >
                  <DxZoomAndPan
                      :drag-to-zoom="true"
                      pan-key="ctrl"
                      argument-axis="both"
                      value-axis="both"
                      :allow-touch-gestures="true"
                  />
                  <DxCommonSeriesSettings type="line" />
                  <DxSeries argument-field="periodOrdinal" value-field="crPY" :color="getOutletStyle.secondaryColor" :name="displayPreviousYear">
                    <DxPoint :color="getOutletStyle.secondaryColor" :size="scatterERLTM.points2.size" :visible="true" />
                  </DxSeries>
                  <DxSeries argument-field="periodOrdinal" value-field="cr" :color="getOutletStyle.primaryColor" :name="displayCurrentYear">
                    <DxPoint :color="getOutletStyle.primaryColor" :size="scatterERLTM.points1.size" :visible="true" />
                  </DxSeries>
                  <DxTooltip :enabled="true" content-template="tooltipTemplateFootfall" :argument-format="scatterERLTM.tooltipCr.argumentFormat" :format="scatterERLTM.tooltipCr.valueFormat" />

                  <DxArgumentAxis :tick-interval="1" :title="loc.FOOTFALL.LINECHARTARGAXISTITLE"  :label="{ customizeText: newArgAxisValue }">
                    <DxGrid :visible="false" />
                    <DxMinorGrid :visible="false" />
                  </DxArgumentAxis>
                  <!--                      todo: applicare colore corretto a grid di entrambi gli assi (e fissare quella di asse argument - anche se di default già ok) -->
                  <!--                      todo: togliere primo e ultimo asse di argument grid -->
                  <DxValueAxis
                      :tick-interval="10"
                      :grid="{ visible: true }"
                      :title="loc.FOOTFALL.LINECHART2VALUEAXISTITLE"
                      :visible="false"
                  />
                  <DxLegend
                      :visible="true"
                      vertical-alignment="bottom"
                      horizontal-alignment="center"
                      :margin="{ top: 25 }"
                      itemTextPosition="right"
                      :font="getLegendFontSettings"
                  />
                  <DxCommonPaneSettings>
                    <DxBorder :visible="false" />
                  </DxCommonPaneSettings>


                  <template #tooltipTemplateFootfall="{ data }">
                    <div style="text-align: center">
                      CR Retail: {{ data.valueText }} %<br>
                      Month: {{ (data.point.series.getValueFields() == "cr") ? data.point.data.periodPlainAlt : data.point.data.periodPlainAltPY}}
                    </div>
                  </template>


                </DxChart>
              </template>

              <template v-slot:componentTab>
                <!-- ## DATAGRID -->
                <DxDataGrid
                    id="dataGrid-filtered-by-client"
                    class="datagrid"
                    :data-source="scatterDatagridERLTM.dataFilteredByProductCategory"
                    key-expr="periodOrdinal"
                    :show-borders="false"
                    :loadPanel="{enabled: true}"
                    @exporting="onExportingDatagridEr"
                    :show-column-lines="false"
                    :show-row-lines="true"
                    :column-auto-width="true"
                    :column-hiding-enabled="true"
                    :noDataText="loc.COMMON.NODATA"
                >
                  <DxPaging :enabled="false" />
                  <DxExport
                      :enabled="true"
                  />
                  <DxColumn
                      css-class="cell-custom-style cell-body-head"
                      data-field="periodOrdinal"
                      :caption="loc.FOOTFALL.DATAGRIDCRCOL1CAPTION"
                      data-type="number"
                      alignment="left"
                      cell-template="ordinal-to-month"
                      sort-order="asc"

                  />
                  <DxColumn
                      css-class="cell-custom-style"
                      data-field="cr"
                      :caption="loc.FOOTFALL.DATAGRIDCRCOL2CAPTION + ' ' + yearText + ' (%)'"
                      data-type="number"
                      alignment="left"
                      :customizeText="customizeDatagridDataDecimals"

                  >
                    <DxFormat
                        type="fixedPoint"
                        :precision="2"
                    />
                  </DxColumn>
                  <DxColumn
                      css-class="cell-custom-style"
                      data-field="crPY"
                      :caption="loc.FOOTFALL.DATAGRIDCRCOL2CAPTION + ' ' + yearTextPy + ' (%)'"
                      data-type="number"
                      alignment="left"
                      :customizeText="customizeDatagridDataDecimals"
                  >
                    <DxFormat
                        type="fixedPoint"
                        :precision="2"
                    />
                  </DxColumn>
                  <DxColumn
                      css-class="cell-custom-style"
                      data-field="varCR"
                      :caption="loc.FOOTFALL.DATAGRIDCRCOL41CAPTION"
                      data-type="number"
                      alignment="left"
                      :customizeText="customizeDatagridDataPercentage"
                      cell-template="posNegCellTemplateSales"
                  >
                    <DxFormat
                        type="fixedPoint"
                        :precision="2"
                    />
                  </DxColumn>

                  <!-- template personalizzato celle datagrid -->
                  <template #diff-cell-template="{ data }">
                    <DiffCell :cell-data="data"/>
                  </template>

                  <template #ordinal-to-month="{ data }">
                    <div>{{ fromOrdinalToMonth(data.value) }}</div>
                  </template>

                  <template #posNegCellTemplateSales="{ data }">
                    <div :class="data.value != null ? data.value < 0 ? 'negative-value' : '' : ''">{{ data.text}}</div>
                  </template>

                </DxDataGrid>
              </template>


            </basic-chart-datagrid-visualizer>
          </div>

        </template>
      </DxItem>
<!--      <DxItem>-->
<!--        <DxLocation :row="3" :col="0" :colspan="3" screen="xs sm md lg" />-->
<!--        <template #default>-->
<!--          <basic-datagrid-visualizer :componentTitle="loc.FOOTFALL.DATAGRIDWORSTTITLE" :refDate="refDateText" :dataReady="pageDataReady">-->
<!--            <template v-slot:componentTab>-->
<!--              &lt;!&ndash;                  datagrid  &ndash;&gt;-->
<!--              &lt;!&ndash;                  <DxDataGrid&ndash;&gt;-->
<!--              &lt;!&ndash;                      id="dataGrid-worst-er"&ndash;&gt;-->
<!--              &lt;!&ndash;                      class="datagrid"&ndash;&gt;-->
<!--              &lt;!&ndash;                      :data-source="dataFilteredByProductCategory"&ndash;&gt;-->
<!--              &lt;!&ndash;                      key-expr="productCategoryID"&ndash;&gt;-->
<!--              &lt;!&ndash;                      :show-borders="false"&ndash;&gt;-->
<!--              &lt;!&ndash;                      :loadPanel="{enabled: true}"&ndash;&gt;-->
<!--              &lt;!&ndash;                  >&ndash;&gt;-->
<!--              <DxDataGrid-->
<!--                  id="dataGrid-worst-er"-->
<!--                  class="datagrid"-->
<!--                  :data-source="datagridERWorstPerformer.dataFilteredByProductCategory"-->
<!--                  key-expr="tenant"-->
<!--                  :show-borders="false"-->
<!--                  :loadPanel="{enabled: true}"-->
<!--                  :show-column-lines="false"-->
<!--                  :show-row-lines="true"-->
<!--              >-->
<!--                <DxPaging :enabled="false" />-->
<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="tenant"-->
<!--                    :caption="loc.FOOTFALL.DATAGRIDWORSTBESTCOL1CAPTION"-->
<!--                    data-type="string"-->
<!--                    alignment="left"-->
<!--                    css-class="cell-custom-style cell-body-head"-->
<!--                    width="249"-->
<!--                    cell-template="diff-cell-template"-->
<!--                />-->
<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="salesLTM"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL2CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataDecimals"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="0"-->
<!--                  />-->
<!--                </DxColumn>-->


<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="salesLTMPY"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL3CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataDecimals"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="0"-->
<!--                  />-->
<!--                </DxColumn>-->
<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="varSales"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL4CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                    cell-template="posNegCellTemplateSales"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="erLTM"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL5CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="erLTMPY"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL6CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="varER"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL7CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                    cell-template="posNegCellTemplateEr"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->
<!--                &lt;!&ndash;                    <DxColumn&ndash;&gt;-->
<!--                &lt;!&ndash;                        data-field="effortRatePercentLTM"&ndash;&gt;-->
<!--                &lt;!&ndash;                        caption="Sale Amount"&ndash;&gt;-->
<!--                &lt;!&ndash;                        data-type="number"&ndash;&gt;-->
<!--                &lt;!&ndash;                        alignment="left"&ndash;&gt;-->
<!--                &lt;!&ndash;                    />&ndash;&gt;-->

<!--                &lt;!&ndash;                    <DxColumn&ndash;&gt;-->
<!--                &lt;!&ndash;                        :allow-grouping="false"&ndash;&gt;-->
<!--                &lt;!&ndash;                        data-field="Discount"&ndash;&gt;-->
<!--                &lt;!&ndash;                        caption="Discount %"&ndash;&gt;-->
<!--                &lt;!&ndash;                        data-type="number"&ndash;&gt;-->
<!--                &lt;!&ndash;                        format="percent"&ndash;&gt;-->
<!--                &lt;!&ndash;                        alignment="right"&ndash;&gt;-->
<!--                &lt;!&ndash;                        cell-template="discountCellTemplate"&ndash;&gt;-->
<!--                &lt;!&ndash;                        css-class="bullet"&ndash;&gt;-->
<!--                &lt;!&ndash;                    />&ndash;&gt;-->

<!--                &lt;!&ndash; template personalizzato celle datagrid &ndash;&gt;-->
<!--                <template #diff-cell-template="{ data }">-->
<!--                  <DiffCell :cell-data="data"/>-->
<!--                </template>-->

<!--                <template #posNegCellTemplateSales="{ data }">-->
<!--                  <div :class="data.value != null ? data.value < 0 ? 'negative-value' : '' : ''">{{ data.value}}</div>-->
<!--                </template>-->

<!--                <template #posNegCellTemplateEr="{ data }">-->
<!--                  <div :class="data.value != null ? data.value > 0 ? 'negative-value' : '' : ''">{{ data.value}}</div>-->
<!--                </template>-->

<!--              </DxDataGrid>-->

<!--            </template>-->
<!--          </basic-datagrid-visualizer>-->
<!--        </template>-->
<!--      </DxItem>-->

      <!-- ############## 4th row ############## -->
<!--      <DxItem>-->
<!--        <DxLocation :row="4" :col="0" :colspan="3" screen="xs sm md lg" />-->
<!--        <template #default>-->
<!--          <basic-datagrid-visualizer :componentTitle="loc .EFFORTRATE.DATAGRIDBESTTITLE" :refDate="refDateText" :dataReady="pageDataReady">-->
<!--            <template v-slot:componentTab>-->
<!--              <DxDataGrid-->
<!--                  id="dataGrid-best-er"-->
<!--                  class="datagrid"-->
<!--                  :data-source="datagridERBestPerformer.dataFilteredByProductCategory"-->
<!--                  key-expr="tenant"-->
<!--                  :show-borders="false"-->
<!--                  :loadPanel="{enabled: true}"-->
<!--                  :show-column-lines="false"-->
<!--                  :show-row-lines="true"-->
<!--              >-->
<!--                <DxPaging :enabled="false" />-->
<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="tenant"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL1CAPTION"-->
<!--                    data-type="string"-->
<!--                    alignment="left"-->
<!--                    css-class="cell-custom-style cell-body-head"-->
<!--                    width="249"-->
<!--                    cell-template="diff-cell-template"-->

<!--                />-->
<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="salesLTM"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL2CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataDecimals"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="0"-->
<!--                  />-->
<!--                </DxColumn>-->


<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="salesLTMPY"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL3CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataDecimals"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="0"-->
<!--                  />-->
<!--                </DxColumn>-->
<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="varSales"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL4CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                    cell-template="posNegCellTemplateSales"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="erLTM"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL5CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="erLTMPY"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL6CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                <DxColumn-->
<!--                    :allow-sorting="false"-->
<!--                    data-field="varER"-->
<!--                    :caption="loc .EFFORTRATE.DATAGRIDWORSTBESTCOL7CAPTION"-->
<!--                    data-type="number"-->
<!--                    alignment="left"-->
<!--                    :customizeText="customizeDatagridDataPercentage"-->
<!--                    css-class="cell-custom-style"-->
<!--                    cell-template="posNegCellTemplateEr"-->
<!--                >-->
<!--                  <DxFormat-->
<!--                      type="fixedPoint"-->
<!--                      :precision="2"-->
<!--                  />-->
<!--                </DxColumn>-->

<!--                &lt;!&ndash; template personalizzato celle datagrid &ndash;&gt;-->
<!--                <template #diff-cell-template="{ data }">-->
<!--                  <DiffCell :cell-data="data"/>-->
<!--                </template>-->

<!--                <template #posNegCellTemplateSales="{ data }">-->
<!--                  <div :class="data.value != null ? data.value < 0 ? 'negative-value' : '' : ''">{{ data.value}}</div>-->
<!--                </template>-->

<!--                <template #posNegCellTemplateEr="{ data }">-->
<!--                  <div :class="data.value != null ? data.value > 0 ? 'negative-value' : '' : ''">{{ data.value}}</div>-->
<!--                </template>-->

<!--              </DxDataGrid>-->

<!--            </template>-->
<!--          </basic-datagrid-visualizer>-->
<!--        </template>-->
<!--      </DxItem>-->

      <!--   footer   -->
<!--      <DxItem>-->
<!--        <DxLocation :row="4" :col="2" :colspan="2" screen="xs sm md lg" />-->
<!--        <template #default>-->
<!--          <div class="app-version">v. {{ getStoredAppVersion.versionNumber }} - {{ getStoredAppVersion.versionDate }}</div>-->
<!--        </template>-->
<!--      </DxItem>-->

    </DxResponsiveBox>

  </div>
</template>

<script>
import itMessages from 'devextreme/localization/messages/it.json';
import { locale, loadMessages } from "devextreme/localization";

import { loc } from "@/config/languages/en.js";

import DxSelectBox from 'devextreme-vue/select-box';
import 'devextreme/dist/css/dx.light.css';
import ApiCalls from "@/services/ApiCalls";

import { mapGetters } from "vuex";
import DxCalendar from 'devextreme-vue/calendar';

import {
  DxResponsiveBox,
  DxItem,
  DxLocation,
  DxCol,
  DxRow,
} from "devextreme-vue/responsive-box";

/******************************************************************************************************
 * # COMPONENTE - INIZIO
 **/

// import { DxBarGauge } from 'devextreme-vue/bar-gauge';

import DxDataGrid, {
  // DxLoadPanel,
  DxPaging, DxColumn, DxFormat, DxExport } from 'devextreme-vue/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

import {
  DxChart,
  DxSeries,
  DxPoint,
  DxCommonSeriesSettings,
  DxLegend,
  DxValueAxis,
  DxArgumentAxis,
  DxGrid,
  DxMinorGrid,
  DxCommonPaneSettings,
  DxBorder,
  DxTooltip,

  DxZoomAndPan,

  // DxSize,
} from "devextreme-vue/chart";

import {
  // DxFormat,
  // DxLabel,
  // DxConnector,
  // DxExport
} from 'devextreme-vue/pie-chart';

import DxButton from 'devextreme-vue/button';


import DiffCell from '@/components/datagrid/DiffCell.vue';

/**
 * # /COMPONENTE - FINE
 ******************************************************************************************************/


export default {
  components: {
    DxResponsiveBox,
    DxItem,
    DxLocation,
    DxCol,
    DxRow,
    DxSelectBox,
    DxButton,
    DxCalendar,

    /******************************************************************************************************
     * # COMPONENTE - INIZIO
     **/
    DxDataGrid,
    // DxLoadPanel,
    DxPaging,
    DxExport,


    DxChart,
    DxSeries,
    DxPoint,
    DxCommonSeriesSettings,
    DxLegend,
    DxValueAxis,
    DxArgumentAxis,
    DxGrid,
    DxMinorGrid,
    DxCommonPaneSettings,
    DxBorder,
    DxTooltip,
    // DxSize,
    DxColumn,
    DxFormat,


    // DxPieChart,
    // DxFormat,
    // DxLabel,
    // DxConnector,
    // DxExport,

    // DxBarGauge,
    DxZoomAndPan,

    DiffCell, // componente per template personalizzato celle datagrid

    /**
     * # /COMPONENTE - FINE
     ******************************************************************************************************/
  },

  data() {
    /***************
     * # PROVVISORIO: ARRIVERà DA VUEX
     ***************/
        // let outlet = this.$store.getters.getSelectedOutlet.id ? this.$store.getters.getSelectedOutlet.id : 1; // #1
        // let refDate = {year: 2021, month: 10};
    let selectedProductCategory = 0;
    // console.log("er outlet from store: ", outlet)

    return {
      /***************
       * # PROVVISORIO: ARRIVERà DA VUEX
       ***************/
      // parametri per composizione chiamate - prov (arriveranno da vuex, impostato da subheader/partials/drop-down component)
      // outletId: outlet, /* #globale */
      // refDate: refDate, /* #globale */

      /******************************************************************************************************
       * # COMPONENTE - INIZIO
       **/

      /** ## DATE PER I COMPONENTI **********/
      refDateYTD: "",
      comparisonDateYTD: "",

      refDateText: "", // arriva da chiamata refDate.plain
      comparisonDateText: "", // arriva da chiamata comparisonDate.plain

      yearText: "",
      yearTextPy: "",

      refDateREF: "",
      comparisonDateREF: "",

      yearTextREF: "",
      yearTextPyREF: "",

      selectedProductCategory: selectedProductCategory, // #globale

      /** ## SELETTORE CATEGORIE MERCEOLOGICHE **********/
      categories: [], // todo: globale o componente? ogni quanto si ripopolerà? verrà preso da localstorage dopo prima chiamata?

      // DATAGRID CATEGORIES COMPONENT
      // selectedCategory: null, // forse non più utile... #check
      /**
       * # /COMPONENTE - FINE
       ******************************************************************************************************/

      /***************
       * # GENERALI E GLOBALI
       ***************/
      effortRateData: null, /************* # COMPONENTE *********************************/
      // dataFilteredByProductCategory: [], // #componente

      // flag per abilitare eventuali pulsanti solo quando i dati sono stati ricevuti
      pageDataReady: false, /************* # COMPONENTE *********************************/

      // flag per abilitare filtro categorie merceologiche (dipende da pagina - domain) #n
      productCategoryFilterDisabledByPage: null,

      /** ## LOCALIZZAZIONE **********/
      locale: "it",

      loc: loc, // labels

      /** ## BREAKPOINTS **********/
      screenByWidth: function (width) {
        if (width < 768) return "xs";
        if (width < 1024) return "sm";
        if (width < 1150) return "md";
        // if (width < 1150) return "md";
        return "lg";
      },

      //Settings
      settingsZoomLevel: "decade",
      settingsMaxSelectableDate: null,
      settingsMinSelectableDate: null,
      settingsHidden: true,

      /** ## CALENDAR **********/
      calendarZoomLevel: "year", /* #componente: impostata di default, dipende da pagina: usata per cambiare stato active */
      maxSelectableDate: null,
      minSelectableDate: null, // #n
      calendarHidden: true,

      /******************************************************************************************************
       * # COMPONENTE - INIZIO
       **/

      /** ## BAR GAUGE **********/
      format: { /* #globale */
        type: 'fixedPoint',
        precision: 1
      },

      /** ## DATAGRID **********/
      customizeDatagridDataDecimals(value) { /* #globale */
        // console.log("custom data col: ", value)
        return value.valueText;
        // return value.valueText + " €";
      },

      customizeDatagridDataPercentage(value) { /* #globale */
        return value.valueText;
        // return value.valueText + " %";
      },

      // datagrid loader chiamata filtrata via api: ancora utile?
      loadingVisible: true, /* #componente */

      /***************
       * # COMPONENT ER LTM DISTRIBUTION - BAR GAUGE
       ***************/
      // todo: trasformare in oggetto ogni componente (solo var componente)?

      barGaugeER: { // #componente
        dataRef: [],
        dataComparison: [],
        legend: {},
      },

      barGaugeGeometry: { /* #globale */
        endAngle:-30,
        startAngle:210
      },
      colorGood: "#59C47F", /* #globale */
      colorNormal: "#FFD341", /* #globale */
      colorBad: "#FF5633", /* #globale */
      barGaugeLabelFont: {family: 'Nunito, sans-serif', size: 18, weight: 400}, /* #globale */
      // todo: label font-size a 15 in 768 e 1024

      /***************
      * # COMPONENT TEXT VISITORS
      ***************/
      textVisitors: {
        dataFilteredByProductCategory: {},
        dataFilteredByProductCategoryREF: {},
      },


      /***************
       * # COMPONENT ER LTM
       ***************/
      scatterDatagridERLTM: {
        // componentTitle: "Effort Rate LTM %",
        metadata: null,
        dataFilteredByProductCategory: null,
      },

      /** ## SCATTER PLOT **********/
      dataDisplayMode1: 'chart', /* #componente: serve a togliere il reset zoom button in seguito ad azione su switch (risolve problema su ipad con chrome) */
      dataDisplayMode2: 'chart', /* #componente: serve a togliere il reset zoom button in seguito ad azione su switch (risolve problema su ipad con chrome) */

      effortRateDisplayMode: "chart", /* #componente */

      scatterErInstance1: null, /* #componente */
      scatterErInstance2: null, /* #componente */

      scatterChartCommonAxisSettings: { /* #globale */
        //todo: color non viene applicato: scoprire cosa lo sovrascrive
        label:
            { font:
                  { size: 14, family: 'Nunito', weight: 400, color: '#787878' }
            },
        title:
            { margin: 14 ,
              font:
                  { size: 14, family: 'Nunito', weight: 400, color: '#666666' }
            }
      },

      scatterERLTM: {
        // argumentAxis: {
        //   title: { text: 'Net Sales (€)'},
        // },
        // valueAxis: {
        //   title: { text: 'E.R. (%)'},
        // },
        series1: {
          color: "#FF5633",
        },
        series2: {
          color: "#F8B5BF",
        },
        points1: {
          color: "#FF7373",
          size: 15,
        },
        points2: {
          color: "#F8B5BF",
          size: 15,
        },
        tooltipVisitors: {
          argumentFormat: { type: 'fixedPoint' },
          valueFormat: { type: 'fixedPoint' },
        },
        tooltipCr: {
          argumentFormat: { type: 'fixedPoint' },
          valueFormat: { type: 'decimal', precision: 2 },
        },
      },

      /***************
       * # COMPONENT WORST PERFORMER - DATAGRID
       ***************/
      datagridERWorstPerformer: {
        // componentTitle: "Worst Performers",
        dataFilteredByProductCategory: null,
      },

      /***************
       * # COMPONENT BEST PERFORMER - DATAGRID
       ***************/
      datagridERBestPerformer: {
        // componentTitle: "Best Performers",
        dataFilteredByProductCategory: null,
      },

      /**
       * # /COMPONENTE - FINE
       ******************************************************************************************************/

    };
  },

  computed: {
    ...mapGetters(["getSelectedOutlet", "getOutletsList", "getCategoriesList", "getOutletLastSalesDates", "getNewOutletLastSalesDates", "getOutletStyle", "getStoredAppVersion", "getLegendFontSettings"]),

    displayCurrentYear() { /* #globale */
      // return new Date().getFullYear();
      // return /\w+\s(\d{4})/.exec(this.scatterDatagridERLTM.metadata.periods[0].plainAlt)[1] + "";
      return this.yearText;
    },

    displayPreviousYear() { /* #globale */
      return this.scatterDatagridERLTM.metadata.yearComparison;
    },

    displayPPreviousYear() { /* #globale */
      return this.scatterDatagridERLTM.metadata.yearComparison2;
    },

    /***************
    * # CALENDAR
    ***************/
    displayStringDate() { /* #globale */
      if(this.$store.state.selectedDate) {
        let year = this.$store.state.selectedDate.slice(0, 4);
        let month = this.fromOrdinalToMonth(Number((this.$store.state.selectedDate.slice(3, 5) - 1)))

        return `${month} ${year}`;
      } else {
        let year = this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate.slice(0, 4);
        let month = this.fromOrdinalToMonth(Number((this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate.slice(3, 5) - 1)))

        return `${month} ${year}`;
      }
    },
  },

  methods: {
    changeDisplayData1(value) { /* #componente: serve a togliere il reset zoom button in seguito ad azione su switch (risolve problema su ipad con chrome) */
      this.dataDisplayMode1 = value;
    },

    changeDisplayData2(value) { /* #componente: serve a togliere il reset zoom button in seguito ad azione su switch (risolve problema su ipad con chrome) */
      this.dataDisplayMode2 = value;
    },

    /***************
     * # CALENDAR
     ***************/

    // funzione per convertire numeri da una a due cifre
    convertFormatDate(date) {
      console.log("date: ", date);
      return String(date).length < 2 ? ("0" + date) : date;
    },

    onSelectedDate(e) {
      // console.log("selectedDate: ", new Date(e.value));
      let temp = new Date(e.value);
      // console.log("temp: ", temp);
      let selectedDate = `${temp.getFullYear()}${this.convertFormatDate(Number(temp.getMonth())+1)}${this.convertFormatDate(temp.getDate())}`
      // console.log("selectedDate: ", selectedDate);

      // imposto data selezionata in vuex
      this.$store.dispatch("dispatchSelectedDate", selectedDate);
      console.log("selectedDate - vuex: ", this.$store.state.selectedDate);

      // chiamata api per riprendere dati pagina er (tenendo conto di categoria selezionata)
      this.getEffortRateData();

      // nascondi il calendario
      this.calendarHidden = true;

    },

    onSelectedSetting(e) {

      let temp = new Date(e.value);
      let selectedSetting = `${temp.getFullYear()}`;
      this.$store.dispatch("dispatchSelectedSetting", selectedSetting);

      this.getEffortRateData();
      this.settingsHidden = true;
    },

    // funzione per impostare il range di date selezionabili (month, week)
    onCalendarZoomLevelSelection(calendarZoomLevelSelected) {
      // impostazione zoom level calendario
      this.calendarZoomLevel = calendarZoomLevelSelected.value;
      console.log("calendar zoom level: ", this.calendarZoomLevel);

      // imposta ultima data selezionabile
      this.setMaxSelectableDate()
    },

    // imposta ultima data selezionabile
    setMaxSelectableDate() {
      if(this.calendarZoomLevel === "year") {
        // console.log("prova start date: ", this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate);
        let tempLastDateYear = (this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate + "").slice(0, 4);
        let tempLastDateMonth = (this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate + "").slice(4, 6);

        // ricavo data di partenza in formato data
        let tempLastDate = new Date(tempLastDateYear, tempLastDateMonth, 0);

        // ricreo la data in formato devextreme e la imposto nel calendario
        this.maxSelectableDate = `${tempLastDate.getFullYear()}${(tempLastDate.getMonth() + 1).toLocaleString(undefined, {minimumIntegerDigits: 2})}${tempLastDate.getDate()}`; // #n

        // console.log("calendar max selectable date: ", this.maxSelectableDate);
        // console.log("calendar max selectable date - old: ", this.$store.state.outletLastSalesDates.salesLastDayClosedMonth);  // old

        //  imposto min data selezionabile su calendario // #n
        console.log("prova start first date: ", this.$store.state.newOutletLastSalesDates.firstAvailableSalesDate);
        let tempFirstDateYear = (this.$store.state.newOutletLastSalesDates.firstAvailableSalesDate + "").slice(0, 4);
        let tempFirstDateMonth = (this.$store.state.newOutletLastSalesDates.firstAvailableSalesDate + "").slice(4, 6);

        // ricavo data di partenza in formato data
        let tempFirstDate = new Date(tempFirstDateYear, tempFirstDateMonth, 1);
        console.log("temp first date: ", tempFirstDate);

        // ricreo la data in formato devextreme e la imposto nel calendario
        this.minSelectableDate = `${tempFirstDate.getFullYear()}${(tempFirstDate.getMonth()).toLocaleString(undefined, {minimumIntegerDigits: 2})}${tempFirstDate.getDate().toLocaleString(undefined, {minimumIntegerDigits: 2})}`; // #n

        this.settingsMaxSelectableDate = `${tempLastDate.getFullYear()-1}${(tempLastDate.getMonth() + 1).toLocaleString(undefined, {minimumIntegerDigits: 2})}${tempLastDate.getDate()}`; // #n;
        this.settingsMinSelectableDate = "2018";
      }

      // if(this.calendarZoomLevel === "month") { // per ora non utilizzato !? attenzione: da aggiornare con lastAvailableSalesDate !? // #n
      //   this.maxSelectableDate = this.$store.state.outletLastSalesDates.salesLastDayClosedWeek;
      // }

      console.log("max selectable data: ", this.maxSelectableDate);
      console.log("calendar min selectable date: ", this.minSelectableDate);
    },

    onShowCalendar() {
      this.calendarHidden === true ? this.calendarHidden = false : this.calendarHidden = true;
    },

    onShowSettings() {
      this.settingsHidden === true ? this.settingsHidden = false : this.settingsHidden = true;
    },

    // getCellCssClass(date) {
    //   let cssClass = '';
    //   const holydays = [[1, 0], [4, 6], [25, 11]];
    //
    //   if (this.isWeekend(date)) { cssClass = 'weekend'; }
    //
    //   holydays.forEach((item) => {
    //     if (date.getDate() === item[0] && date.getMonth() === item[1]) {
    //       cssClass = 'holyday';
    //     }
    //   });
    //
    //   return cssClass;
    // },

    /***************
    * # DATAGRID CHART
    ***************/
    /** ## CONVERTE GLI ORDINALI IN MESI (FOOTFALL, ...) **********/
    fromOrdinalToMonth(ordinalNumber) { /* #globale */
      // console.log("fn fromOrdinalToMonth called");

      if(typeof ordinalNumber != "number") {
        ordinalNumber = Number(ordinalNumber)
      }

      let output = ordinalNumber;
      switch(ordinalNumber) {
        case 1:
          output = "Jan";
          break;
        case 2:
          output = "Feb";
          break;
        case 3:
          output = "Mar";
          break;
        case 4:
          output = "Apr";
          break;
        case 5:
          output = "May";
          break;
        case 6:
          output = "Jun";
          break;
        case 7:
          output = "Jul";
          break;
        case 8:
          output = "Aug";
          break;
        case 9:
          output = "Sep";
          break;
        case 10:
          output = "Oct";
          break;
        case 11:
          output = "Nov";
          break;
        case 12:
          output = "Dec";
          break;
        default:
          output = "-";
      }

      return output;
    },

     /** ## VALORE VISUALIZZATO IN ARGUMENT AXIS **********/
    newArgAxisValue(value) {
      return this.fromOrdinalToMonth(value.value);
    },

    /***************
     * # GENERALE
     ***************/
    onDrawn(e) { /* #globale */
      setTimeout(function () {
        e.component.render()
      }, 1)
    },

    /** ## FILTRO OUTLETS - parte 1: impostazione filtro e chiamate api **********/
    onOutletSelected(e) {
      console.log("selezionato outlet: ", e.value);

      // condizione per pulsante clear: onclick passa null -> defaultOutlet
      let selectedOutletId = e.value == null ? 1 : e.value;

      // ricavo l'outlet dall'id selezionato (in vuex selectedOutlet è l'obj completo)
      let selectedOutlet = this.$store.state.outletsList.filter(outlet => outlet.id == selectedOutletId)[0];

      // invio l'outlet selezionato a vuex
      this.$store.dispatch("dispatchSelectedOutlet", selectedOutlet)

      console.log("selected outlet - vuex: ", this.$store.state.selectedOutlet);

      // al cambio di outlet, reimposto le categorie a 0 (all): non tutti gli outlets hanno le stesse categorie
      this.$store.dispatch("dispatchSelectedCategory", 0);
      // reimpostare anche selectbox categorie
      console.log("on outlet change, reset selected category - vuex: ", this.$store.state.selectedCategory);

      // recupero le categorie dell'outlet e le imposto nel vuex
      this.getDataByCategories();

      // reimposto le ultime date selezionabili in calendario
      this.setMaxSelectableDate();
    },

    /** ## CHIAMATA API FILTRO OUTLETS (anche chiamata iniziale pagina) **********/
    getEffortRateData() {
      console.log("getEffortRateData called");

      // recupero variabili per chiamata da store
      let outletId = this.$store.state.selectedOutlet.id;
      // console.log("api call - outletId: ", outletId);

      let outletsDatesYear = "";
      let outletsDatesMonth = "";

      let yearComp = "";

      // controllo che selected date non sia impostata: se == null, cambiato selezione outlet o primo caricamento pagina: perciò prendo ultima data da outlet
      if(this.$store.state.selectedDate == null) {
        //#n
        outletsDatesYear = (this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate + "").slice(0, 4); // nel caso arrivi un numero, trasformo in stringa // #n
        console.log("api call - outletsDatesYear", outletsDatesYear);
        // outletsDatesMonth = 10; // temp per test: non ci sono tutti i dati per l'ultimo mese fornito dalle api  // todo: ricordati di passare alla modalità non test
        outletsDatesMonth = (this.$store.state.newOutletLastSalesDates.lastAvailableSalesDate + "").slice(4, 6); // #n
        console.log("api call - outletsDatesMonth", outletsDatesMonth); // /#n
      } else {
        outletsDatesYear = this.$store.state.selectedDate.slice(0, 4);
        console.log("api call - outletsDatesYear", outletsDatesYear);
        // outletsDatesMonth = 10;
        outletsDatesMonth = this.$store.state.selectedDate.slice(4, 6);
        console.log("api call - outletsDatesMonth", outletsDatesMonth);
      }

      if(this.$store.state.selectedSettings == null) {

        yearComp = outletsDatesYear-1;

      } else {

        yearComp = this.$store.state.selectedSettings;
      }

      ApiCalls.getFootfall(outletId, outletsDatesYear, outletsDatesMonth, yearComp)
          .then(res => {
            console.log("chiamata api er res: ", res.data);

            // #n
            // imposta dominio in vuex per decidere quali filtri lasciare attivi
            let currentDomain = res.data.metadata.domain;
            this.$store.dispatch("dispatchCurrentDomain", currentDomain);
            // console.log("vuex domain: ", this.$store.state.currentDomain);

            // flag per disabilitare filtri a seconda della pagina
            if(this.$store.state.pagesDisabledFilters.productCategoryFilter.some(domain => domain == currentDomain)) {
              this.productCategoryFilterDisabledByPage = true;

              // se filtro disabilitato, visualizza tutte le categorie merceologiche
              this.$store.dispatch("dispatchSelectedCategory", 0);
            } else {
              this.productCategoryFilterDisabledByPage = false;
            }
            // console.log("productCategoryFilterDisabledByPage: ", this.productCategoryFilterDisabledByPage);
            // /#n

            // salvataggio dati pagina er
            this.effortRateData = res.data; /* #componente */ /************* # COMPONENTE *********************************/

            // fn a parte (cambia per singolo componente): distribuisce dati ai vari componenti
            this.setComponentsData()
            // /fn a parte

          })
          .catch(err => console.log(err.response));
    },


    /** ## CHIAMATA LOCALE FILTRO CLIENT - CATEGORIE **********/
    onProductCategorySelected(e) {

      // imposto selectedCategory in vuex
      console.log("selezionato categoria: ", e.value);
      e.value == null ?
          this.$store.dispatch("dispatchSelectedCategory", 0):
          this.$store.dispatch("dispatchSelectedCategory", e.value);

      console.log("selected category - vuex: ", this.$store.state.selectedCategory);

      // rivalorizzo i dataset dei vari componenti
      this.setComponentsData();
    },

    /** ## VALORIZZAZIONE DATASET DEI VARI COMPONENTI **********/
    setComponentsData() {

      /******************************************************************************************************
       * # COMPONENTE - INIZIO
       **/

      let result = this.effortRateData.result; /************* # COMPONENTE *********************************/
      let metadata = this.effortRateData.metadata; /************* # COMPONENTE *********************************/
      let selectedProductCategory = this.$store.state.selectedCategory;

       /** ## DATA PER LEGEND **********/
       this.scatterDatagridERLTM.metadata = metadata;
       console.debug(`legend metadata: `, metadata);

      // proprietà che verrà usata per filtrare i tenants a seconda delle categorie di prodotto: se categoria negativa, fitrerò su food / non food, altrimenti su categoria prodotto
      let targetProperty = selectedProductCategory < 0 ? "prodCatClusterId" : "prodCatId";

      /** ## DATA FOR TEXT VISITORS **********/
      this.textVisitors.dataFilteredByProductCategory = result.footfallTotalsYTD.filter(el => el[targetProperty] === selectedProductCategory)[0];
      console.log("foofall total filterd: ", this.textVisitors.dataFilteredByProductCategory);

      this.textVisitors.dataFilteredByProductCategoryREF = result.footfallSnapshot.filter(el => el[targetProperty] === selectedProductCategory)[0];
      console.log("foofall snapshot filterd: ", this.textVisitors.dataFilteredByProductCategoryREF);

      // dates
      this.refDateYTD = metadata.periods.find(obj => obj.type == "YTD").plainAlt;
      this.comparisonDateYTD = metadata.periodsComparison.find(obj => obj.type == "YTD").plainAlt;

      this.yearText = this.refDateYTD.slice(-4);
      this.yearTextPy = this.comparisonDateYTD.slice(-4);

      this.refDateREF = metadata.periods.find(obj => obj.type == "REF").plainAlt;
      this.comparisonDateREF = metadata.periodsComparison.find(obj => obj.type == "REF").plainAlt;

      this.yearTextREF = this.refDateYTD.slice(-4);
      this.yearTextREFPy = this.comparisonDateYTD.slice(-4);

      /** ## DATA FOR LINE CHART E DATAGRID **********/
      this.scatterDatagridERLTM.dataFilteredByProductCategory = result.footfallDetailsYTD.filter(el => el[targetProperty] === selectedProductCategory)[0].items;
      console.log("scatterDatagridERLTM.dataFilteredByProductCategory all: ", this.scatterDatagridERLTM.dataFilteredByProductCategory);

      /***** ### flag per abilitare eventuali button o select *****/
      this.pageDataReady = true; /* #componente */
    },

    /******************************************************************************************************
     * # COMPONENTE - INIZIO
     **/

    /***************
     * # BAR GAUGE
     ***************/
    customizeText({valueText}) {
      return `${valueText} %`;
    },

    /***************
     * # DATAGRID
     ***************/
    /** ## EXPORT BUTTON **********/
    onExportingDatagridEr(e) { /* #globale */
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');
      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        customizeCell: function (options) {
          const excelCell = options;
          excelCell.font = {name: 'Arial', size: 12};
          excelCell.alignment = {horizontal: 'left'};
        }
      }).then(function () {
        workbook.xlsx.writeBuffer()
            .then(function (buffer) {
              saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'DataGrid.xlsx');
            });
      });
      e.cancel = true;
    },

    /***************
     * # SCATTER
     ***************/
    /** ## RESET ZOOM BUTTON **********/
    saveScatterErInstance1(e) {
      this.scatterErInstance1 = e.component;
    },

    resetScatterErZoom1() {
      console.log(this.scatterErInstance1)
      this.scatterErInstance1.resetVisualRange()
      // this.scatterErInstance.ActualAxisY.ActualVisualRange.SetAuto();
    },

    saveScatterErInstance2(e) {
      this.scatterErInstance2 = e.component;
    },

    resetScatterErZoom2() {
      console.log(this.scatterErInstance2)
      this.scatterErInstance2.resetVisualRange()
      // this.scatterErInstance.ActualAxisY.ActualVisualRange.SetAuto();
    },

    /** ## TOOLTIP **********/

    //  DATAGRID WORST EFFORT RATE
    //   sortDataWorstER(data) {
    //     return data.sort((a,b) => b.effortRatePercentLTM - a.effortRatePercentLTM);
    //   },
  },

  /**
   * # /COMPONENTE - FINE
   ******************************************************************************************************/

  beforeCreate() {
    // this.outletId = this.$store.getters.getSelectedOutlet.id; // #1
  },

  created() {
    // -- primo accesso all'app

    // CHIAMATA API MAIN.JS INIZIALE
    // 0. main.js fa le varie chiamate api per prendere le liste dei filtri (store - e data -, categorie) e li salva in vuex -> ho i dati per popolare i filtri
    //    (_ controllo localStorage per outlet)
    //    (_ salva dati in local storage)

    // -- primo accesso alla pagina
    // "CHIAMATA LOCALE" A VUEX PER PRENDERE I FILTRI ->
    // 1. prendo dati per popolare i filtri da vuex via getters: store, prodCatId/, dates -> popolo i filtri

    // CHIAMATA API PAGINA ER INIZIALE -> fn api
    // 2. prendo i filtri selezionati da vuex (default per primo accesso: prodCatId = 0, store = 1, data = data corrente (mese, ... dipende da pagina))
    // 3. faccio chiamata api con filtri selezionati (punto 2) per popolare i componenti;
    //    _ salvo i dati della chiamata api in una variabile per poterli usare con il filtro lato client
    //    _ popolo i data-set dei vari componenti con la variabile appena valorizzata

    // -- / fine primo accesso alla pagina

    // CHIAMATA LOCALE FILTRO CLIENT (CATEGORIE) -> fn client
    // 4. al click su filtro categorie, chiamo fn client
    // 5. fn:
    //    _ salva il filtro selezionato in vuex
    //    _ prendo i dati er salvati nella variabile locale, li filtro e li salvo nei dataset dei vari componenti

    // CHIAMATA API FILTRO DATA / OUTLET
    // 6. al click su filtro data / outlet,
    // 7. salvo filtro selezionato su vuex -> fn (una commit, action per variabile o una per tutte e 3?)
    // 8. chiamo fn api




    /***************
     * # LOCALIZZAZIONE
     ***************/
    loadMessages(itMessages);
    locale(this.locale);

    // #todo: adottare sintassi con params xé + chiara?

    // console.log("vuex: ", this.$store);

    /***************
     * # 0: main.js
     ***************/
    this.getOutletsData();

  },



};

// todo: chiedere perché componenti scoped prevengono alcune regole css (es: css-class in dxcolumn
</script>

<style lang="scss" scoped>
/***************
* # FILTRI
***************/
//
//.filterContainer { /* #globale */
//  padding: 10px;
//  display: flex;
//  justify-content: space-between;
//  flex-direction: row !important;
//  align-items: center;
//
//  //h2 {
//  //  font-family: Nunito, sans-serif;
//  //  font-size: 26px;
//  //  font-weight: 600;
//  //
//  //  @media screen and (max-width: 1024px){
//  //    font-size: 22px;
//  //  }
//  //}
//
//  //#categoriesListProv {
//  //  text-align: center;
//  //  padding: 7px;
//  //  border: none;
//  //  border-radius: 14px;
//  //  appearance: none;
//  //
//  //  color: #AA192F;
//  //  background-color: #FDE5E8;
//  //  //width: 117px;
//  //  //height: 24px;
//  //}
//
//}

/** ## CALENDAR **********/


/***************
* # BAR GAUGE
***************/
.gauge {
  height: 232px;
}

/***************
* # SCATTER - DATAGRID
***************/
.scatterChart, .datagrid {
  height: 413px;
}


/***************
* # COMPONENT WORST PERFORMER - DATAGRID
***************/

/*** ***** #!! ATTENZIONE: alcuni elementi css non vengono presi xé il componente è scoped
 -> passarli in custom-style.css !! */

//.tenant-column {
//  color: orange !important;
//  font-size: 50px !important;
//  background-color: green !important;
//}
//
//
//.cell-highlighted {
//  background-color: green !important;
//  color: orange !important;
//  font-style: italic !important;
//  font-size: 25px !important;
//}


// boh? #check
.logos-container {
  margin: 20px 0 40px 0;
  text-align: center;
  svg {
    display: inline-block;
  }
}

.devextreme-logo {
  width: 200px;
  height: 34px;
  margin-bottom: 17px;
}

.vue-logo {
  width: 180px;
  height: 62px;


}

.plus {
  margin: 20px 10px;
  width: 22px;
  height: 22px;
}

.screen-x-small .logos-container {
  svg {
    width: 100%;
    display: block;
    &.plus {
      margin: 0;
    }
  }
}
// /boh? #check


@media screen and (max-width: 1024px) {
  .gauge { // #check: da mettere in custom-style? Pensaci dopo aver fatto tutte le pagine.
    height: 175px;
  }

  .scatterChart, .datagrid { // #check: da mettere in custom-style? Pensaci dopo aver fatto tutte le pagine.
    height: 313px;
  }
}
@media screen and (max-width: 768px) {


}
</style>
